import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
import LoginPage from '@/pages/LoginPage'
import ShellPage from '@/pages/ShellPage'
import PopoutPage from '@/pages/PopoutPage'
import DiagnosticoPage from '@/pages/DiagnosticoPage'

function AuthedRoutes() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/popout/:appId/:instanceId" element={<PopoutPage />} />
        <Route path="/" element={<ShellPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  )
}

export function App() {
  return (
    <Routes>
      <Route path="/diagnostico" element={<DiagnosticoPage />} />
      <Route path="/*" element={<AuthedRoutes />} />
    </Routes>
  )
}
